(function () {
    'use strict';

    angular
        .module('app')
        .factory('trackingService', ['$window', trackingService]);

    function trackingService($window) {
        return {
            trackEvent: function (action, position) {
                if (typeof $window.DataMappingInterface !== 'undefined') {
                    $window.DataMappingInterface.init({
                        eventAction: 'linkClick',
                        eventCode: 'Link_Click',
                        prioritypush: true,
                        additionaldata: {
                            'events.linkName': action,
                            'events.linkPositions': position || 'Body'
                        },
                        datatransform: false
                    });
                }
            }
        }
    };

})();